export const SiteMapRoutes = {
	Home: "/",
	Login: "/login",

	ProfessionalProfile: "/professional-profile",

	Questionnaire: "/questionnaire",
	Report: "/report",
	ReportV2: "/profile-report",
};

export const ProfessionalProfileRoutes = {
	Questionnaire: `${SiteMapRoutes.ProfessionalProfile}${SiteMapRoutes.Questionnaire}`,
	Report: `${SiteMapRoutes.ProfessionalProfile}${SiteMapRoutes.Report}`,
	ReportV2: `${SiteMapRoutes.ProfessionalProfile}${SiteMapRoutes.ReportV2}`,
};
